import React from "react";
import config from './../../config.js';

export default class EditSubject extends React.Component {
    constructor(props) {
        super(props);
        //console.log(props.subject.user.company_id)
        this.state = {
            subject: props.subject,
            companyid: props.subject.user.company_id
        }
        this.handleInputChange = this.handleInputChange.bind(this)
    }

    componentDidMount() { }

    componentWillReceiveProps(nextProps) {
        this.setState({
            subject: nextProps.subject
        })
    }

    handleInputChange(event) {
        this.props.handleInputChange(event)
    }

    render() {
        let {
            subject,
            companyid
        } = this.state;
        return (<div>
            <div className="form-group row"><label className="col-sm-2 col-form-label col-form-label-sm text-right">名称：{subject.company_id}</label>
                <div className="col-sm-10">
                    <input type="text" maxLength="120" className="form-control" name="subject_name" placeholder="受试者名称或编号" value={subject.subject_name} onChange={this.handleInputChange} />
                </div>
            </div>
            {
                companyid == 5 &&
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label col-form-label-sm text-right">UID：</label>
                    <div className="col-sm-10">
                        <input type="text" maxLength="120" className="form-control" name="subject_uid" placeholder="受试者 UID" value={subject.subject_uid} onChange={this.handleInputChange} />
                    </div>
                </div>
            }

            <div className="form-group row">
                <label className="col-sm-2 col-form-label col-form-label-sm text-right">年龄：</label>
                <div className="col-sm-3">
                    <input type="text" maxLength="8" className="form-control" name="subject_age" placeholder="年龄" value={subject.subject_age} onChange={this.handleInputChange} />
                </div>

                <label className="col-sm-2 col-form-label col-form-label-sm text-right">性别：</label>
                <div className="col-sm-3 my-2 ">
                    <label className="control-label mr-3">
                        <input type="radio" name="subject_gender" className="control-input" checked={subject.subject_gender === '0'} value="0" onChange={this.handleInputChange} />
                        男 </label>

                    <label className="control-label" >
                        <input type="radio" name="subject_gender" className="control-input" checked={subject.subject_gender === '1'} value="1" onChange={this.handleInputChange} />
                        女 </label>

                </div>
            </div>
            <div className="form-group row">
                <label className="col-sm-2 col-form-label text-right">说明：</label>
                <div className="col-sm-10">
                    <textarea className="form-control" maxLength="500" name="subject_explain" placeholder="诊断说明..." value={subject.subject_explain || ''} onChange={this.handleInputChange} ></textarea>
                </div>
            </div>
        </div>)
    }

}


// WEBPACK FOOTER //
// ./src/apps/console/uncategorized/edit_subject.js